import { MdPayment } from 'react-icons/md';
import SectionLabelWithIcon from 'components/typography/SectionLabelWithIcon';
import { fontSemiBold, textLg, textLgLineHeight } from './styleConstants';

export default function HowToProceed({ xMargins = {}, marginTop = {} }) {
  return (
    <>
      <SectionLabelWithIcon
        label="How to Proceed"
        icon={<MdPayment />}
        iconClassName="text-2xl"
        style={{
          paddingBottom: '1rem',
          borderBottomWidth: '1px',
          ...xMargins,
          ...marginTop,
        }}
        isPdf
      />
      <p
        style={{
          fontSize: textLg,
          lineHeight: textLgLineHeight,
          marginTop: '1rem',
          marginBottom: '1rem',
          ...xMargins,
        }}
      >
        Making a payment
      </p>
      <p style={{ marginTop: '1rem', marginBottom: '1rem', ...xMargins }}>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed sem augue,
        dictum id pharetra quis, elementum quis enim. Nulla id lacinia sem,
        malesuada feugiat eros. Fusce nec turpis commodo, vehicula lorem rutrum,
        dictum neque. Fusce imperdiet libero nunc, ac cursus ex aliquam at.
        Mauris vel finibus est. Phasellus elementum scelerisque ultricies.
        Aliquam nec elit ipsum. Cras dui orci, tincidunt eu ex sed, suscipit
        interdum tellus. Pellentesque egestas turpis quis feugiat sodales. Proin
        auctor tincidunt elit, in sodales lacus semper consequat. Curabitur
        sodales libero in enim ultrices imperdiet. Duis ac sagittis diam.
      </p>
      <p style={{ fontWeight: fontSemiBold, ...xMargins }}>Contact me</p>
      <div style={{ display: 'flex', ...xMargins }}>
        <p style={{ paddingRight: '.5rem' }}>Tel: 012232343</p>
        <p>Email address: Jordan.Lambert@suntravel.co.uk</p>
      </div>
    </>
  );
}
